(() => {
  const MOBILE_BREAKPOINT = '(max-width: 990px)';

  function initCartSticky() {
    const cartEl = document.querySelector('cart-items.cart');
    if (!cartEl) return;

    const checkoutBtn = cartEl.querySelector('.jsc_cart__checkout');
    const summaryActions = cartEl.querySelector('.cart__summary-actions');
    if (!checkoutBtn || !summaryActions) return;

    const mq = window.matchMedia(MOBILE_BREAKPOINT);
    let io = null;

    const setSmileLauncherOffset = isSticky => {
      document.documentElement.classList.toggle('cart-checkout-sticky-active', !!isSticky);
    };

    const setStickyHeightVar = () => {
      const height = Math.ceil(checkoutBtn.getBoundingClientRect().height || 0);
      if (height > 0) {
        cartEl.style.setProperty('--cart-checkout-sticky-height', `${height}px`);
      }
    };

    const setStickyStateFromViewport = () => {
      const rect = summaryActions.getBoundingClientRect();
      const isInView = rect.bottom > 0 && rect.top < window.innerHeight;
      const shouldStick = !isInView;
      checkoutBtn.classList.toggle('is-sticky', shouldStick);
      setSmileLauncherOffset(shouldStick);
    };

    const enable = () => {
      cartEl.classList.add('cart--sticky-checkout-enabled');
      setStickyHeightVar();

      if (io) io.disconnect();
      io = new IntersectionObserver(
        entries => {
          const entry = entries && entries[0];
          const isInView = !!(entry && entry.isIntersecting);
          const shouldStick = !isInView;
          checkoutBtn.classList.toggle('is-sticky', shouldStick);
          setSmileLauncherOffset(shouldStick);
        },
        { threshold: 0.01 }
      );
      io.observe(summaryActions);

      // Ensure correct state immediately (before observer callback fires)
      setStickyStateFromViewport();
    };

    const disable = () => {
      cartEl.classList.remove('cart--sticky-checkout-enabled');
      checkoutBtn.classList.remove('is-sticky');
      setSmileLauncherOffset(false);
      if (io) {
        io.disconnect();
        io = null;
      }
    };

    const update = () => {
      if (mq.matches) enable();
      else disable();
    };

    // Initial
    update();

    // Responsive changes
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', update);
    else if (typeof mq.addListener === 'function') mq.addListener(update);

    // Keep height var in sync
    window.addEventListener(
      'resize',
      () => {
        if (!cartEl.classList.contains('cart--sticky-checkout-enabled')) return;
        setStickyHeightVar();
        setStickyStateFromViewport();
      },
      { passive: true }
    );

    // Re-calc after cart updates (theme uses jQuery events)
    if (window.jQuery) {
      window.jQuery(document).on('cart.requestComplete cart:updated', () => {
        setTimeout(() => {
          setStickyHeightVar();
          setStickyStateFromViewport();
        }, 0);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartSticky);
  } else {
    initCartSticky();
  }
})();

